var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-level flex-top" },
    [
      _c(
        "div",
        { staticClass: "flex flex-row" },
        [
          _c("avatar", { attrs: { avatar: _vm.person.avatar, size: "big" } }),
          _vm._v(" "),
          _c("div", { staticClass: "dinlineb valign-middle ml-3" }, [
            _c("h4", { staticClass: "mt-0 mb-1" }, [
              _c(
                "a",
                {
                  class: _vm.person.isArchived
                    ? "gray-60"
                    : "black-link semibold",
                  attrs: { href: "/peoples/" + _vm.person.peopleId }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.civilityName) +
                      "\n                "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.person.position
              ? _c("div", { staticClass: "fs-3 gray-60" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.person.position) +
                      "\n            "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.person.mainContactDunning
              ? _c("div", { staticClass: "fs-3 gray-60" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$l10n.__("Contact de relance")) +
                      "\n            "
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex" }, [
        _c("ul", { staticClass: "m-0" }, [
          _vm.person.email !== ""
            ? _c(
                "li",
                { staticClass: "mb-1 fs-3 mb-1 copy-element" },
                [
                  _c("i", { staticClass: "icon-email mr-2 gray-60" }),
                  _vm._v(" "),
                  _c(
                    "email-link",
                    {
                      staticClass: "regular",
                      attrs: {
                        linkedtype: "people",
                        linkedid: parseInt(_vm.person.peopleId),
                        disabled: _vm.person.isArchived,
                        email: _vm.person.email
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.person.email) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.person.email
                    ? _c("SaasClipboard", { attrs: { data: _vm.person.email } })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.person.phone !== ""
            ? _c(
                "li",
                { staticClass: "mb-1 fs-3 mb-1 copy-element" },
                [
                  _c("i", { staticClass: "icon-sellsyphone mr-2 gray-60" }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      class: _vm.person.isArchived ? "gray-60" : "black-link",
                      attrs: {
                        href:
                          _vm.phonecallProtocol +
                          ":" +
                          _vm.person.phone.replace(/[^\+\d]/g, "")
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.person.phone) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.person.phone
                    ? _c("SaasClipboard", { attrs: { data: _vm.person.phone } })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.person.mobile !== ""
            ? _c(
                "li",
                { staticClass: "mb-1 fs-3 mb-1 copy-element" },
                [
                  _c("i", { staticClass: "icon-sellsyphone mr-2 gray-60" }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      class: _vm.person.isArchived ? "gray-60" : "black-link",
                      attrs: {
                        href:
                          _vm.phonecallProtocol +
                          ":" +
                          _vm.person.mobile.replace(/[^\+\d]/g, "")
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.person.mobile) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.person.mobile
                    ? _c("SaasClipboard", {
                        attrs: { data: _vm.person.mobile }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.person.actions && _vm.person.actions.length > 0
        ? _c(
            "div",
            [
              _c("dropdown-multi-level", {
                attrs: {
                  actions: _vm.person.actions,
                  permissions: _vm.permissions
                },
                on: {
                  clicked: function(clickedValue) {
                    return _vm.$emit("clicked", clickedValue, _vm.person)
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }